module.exports = __webpack_public_path__ + "static/img/hausv1.aacdba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/hausv1.jpg
// module id = 3bqw
// module chunks = 1